/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/lightning";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Lightning";
export { I as Lightning };
